// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__M77hA"};